// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"608fad26","453":"181f0549","462":"991bb1a5","494":"068fc468"}[chunkId] + ".chunk.js";
};